import React from 'react';
import CurrencyDisplay from './CurrencyDisplay';

interface CartItemRowProps {
  item: any;
  apiItem?: any;
  primaryColor: string;
  deletingItemId: string | null;
  updatingQuantityId: string | null;
  onRemove: (id: string) => void;
  onChangeQty: (id: string, q: number) => void;
  isRTL?: boolean;
}

export function CartItemRow({
  item,
  apiItem,
  primaryColor,
  deletingItemId,
  updatingQuantityId,
  onRemove,
  onChangeQty,
  isRTL = false,
}: CartItemRowProps) {
  const itemId = item.id as string;
  const additionals = apiItem?.meals?.[0]?.additionals ?? [];
  const unitPrice = apiItem?.total_unit_price ?? item.price;
  
  // Get product information from API data
  const meal = apiItem?.meals?.[0];
  const productName = meal?.product?.name || item.name;
  const size = meal?.size;

  return (
    <div className="p-4">

      <div dir={isRTL ? 'rtl' : 'ltr'} className="flex items-start justify-between gap-3 ">
            {/* images */}
            <div className="shrink-0">
          <img
            src={item.image || "/placeholder.svg"}
            alt={productName}
            className="w-[72px] h-[72px] min-w-[72px] min-h-[72px] p-1.5 bg-gray-100  rounded-lg object-cover"
          />
        </div>
        {/* text */}
        <div className="flex-1 min-w-0">
          <h3 className={`${isRTL ? 'text-right' : 'text-left'} text-[15px] font-semibold text-[color:var(--text)] leading-6 truncate`}>
            {productName} {size && `(${size})`}
          </h3>

          {additionals.length > 0 && (
            <p className={`mt-1 ${isRTL ? 'text-right' : 'text-left'} text-[13px] text-[color:var(--muted)] leading-6 line-clamp-2`}>
              {additionals.map((a: any) => a.name).join(" - ")}
            </p>
          )}

          {/* button + price */}
          <div className="mt-3 flex items-center justify-between">

            {/* السعر */}
            <div
              className="flex items-center gap-1.5 text-base font-bold"
              style={{ color: primaryColor || "var(--brand)" }}
              dir="ltr"
            >
              <CurrencyDisplay iconStyle={{ color: primaryColor || "var(--brand)" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
                <path d="M15.9999 15.0621C15.8942 15.9172 15.8479 16.2882 15.4531 17.1217L9.38959 18.3737C9.52897 17.4728 9.71455 16.7777 10.0165 16.361L15.9999 15.0621ZM7.55463 9.16565L9.36615 8.77307V3.04749C10.0413 2.28964 10.4565 1.94932 11.2714 1.51917V8.35901L15.9999 7.33264C15.8942 8.1875 15.8478 8.55802 15.4531 9.39124L11.2714 10.275V12.1989L15.9999 11.1979C15.8942 12.053 15.848 12.4239 15.4531 13.2574L11.2714 14.1207V14.1383L9.36615 14.5319V10.6774L7.55463 11.0602V13.4899L7.52338 13.4957C7.10666 14.2265 6.51821 15.1044 5.95111 15.8053L0 16.9391C0.0533 16.1734 0.1644 15.7416 0.5107 14.9703L5.64935 13.8561V11.4635L0.8867 12.4713C0.94 11.7056 1.0522 11.2747 1.3984 10.5035L5.64935 9.57971V1.98206C6.32448 1.22421 6.73971 0.883893 7.55463 0.453735V9.16565Z"
                  fill="currentColor"/>
              </svg>
              </CurrencyDisplay>
              <span>{unitPrice}</span>
            </div>
            {/* button delete + nubers */}
            <div className="flex items-center gap-2">
              <button
                onClick={() => onRemove(itemId)}
                disabled={deletingItemId === itemId}
                className="h-8 w-8 rounded-lg border border-gray-200 grid place-items-center hover:bg-gray-50 disabled:opacity-50"
                aria-label="حذف"
              >
                {deletingItemId === itemId ? (
                  <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" className="opacity-25"/>
                    <path d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="3" className="opacity-75"/>
                  </svg>
                ) : (
                  <img src="/delete.svg" alt="Delete" className="h-4 w-4" />
                )}
              </button>

              <div className="inline-flex overflow-hidden rounded-lg border border-gray-200">
  <button
    onClick={() => onChangeQty(itemId, Math.max(1, item.quantity - 1))}
    disabled={item.quantity <= 1 || updatingQuantityId === itemId}
    className="w-10 h-8 grid place-items-center hover:bg-gray-50 disabled:opacity-50"
    aria-label="إنقاص"
  >
    {updatingQuantityId === itemId ? (
      <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" className="opacity-25"/>
        <path d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="3" className="opacity-75"/>
      </svg>
    ) : ("–")}
  </button>

  {/* العدد — خلي حدود الوسط رمادي 200 */}
  <div className="w-12 h-8 grid place-items-center border-x border-gray-200">
    <span className="text-[13px] font-semibold select-none">{item.quantity}</span>
  </div>

  <button
    onClick={() => onChangeQty(itemId, item.quantity + 1)}
    disabled={updatingQuantityId === itemId}
    className="w-10 h-8 grid place-items-center hover:bg-gray-50 disabled:opacity-50"
    aria-label="زيادة"
  >
    {updatingQuantityId === itemId ? (
      <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" className="opacity-25"/>
        <path d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="3" className="opacity-75"/>
      </svg>
    ) : ("+")}
  </button>
</div>

            </div>

          </div>
        </div>

    
      </div>
    </div>
  );
}
